import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { Editable, H6, Icon } from "@alternative/components";
import { IconNames } from "@alternative/icons";

const TREE_NODE_CONTENT = "at-tree-node-content";
const TREE_NODE_CARET = "at-tree-node-caret";
const TREE_NODE_CARET_OPEN = `${TREE_NODE_CARET}--open`;
const TREE_NODE_CARET_CLOSED = `${TREE_NODE_CARET}--closed`;
const TREE_NODE_CARET_NONE = `${TREE_NODE_CARET}--none`;

const TREE_NODE_CONTENT_DRAG_HANDLE = `${TREE_NODE_CONTENT}__drag-handle`;
const TREE_NODE_CONTENT_NODE_NAME = `${TREE_NODE_CONTENT}__node-name`;

const TREE_NODE = "at-tree-node";
const TREE_NODE_COLLAPSED = `${TREE_NODE}--collapsed`;

const EditableInput = (props) => {
  const { defaultValue, isEditable, onSubmit, ...otherprops } = props;
  const [value, setValue] = useState(defaultValue);
  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);
  const ref = useRef();
  const title = <H6>{value}</H6>;
  if (!isEditable) return title;
  return (
    <Editable
      className={TREE_NODE_CONTENT_NODE_NAME}
      childRef={ref}
      {...otherprops}
      text={title}
      type="input"
      showIcon={false}
    >
      <input
        ref={ref}
        type="text"
        value={value}
        onFocus={(e) => e.target.select}
        onChange={(e) => {
          setValue(e.target.value);
        }}
        onKeyDown={(e) => {
          if (!onSubmit) return;
          if (e.key === "Enter") {
            onSubmit(value);
          }
        }}
        onBlur={() => {
          if (!onSubmit) return;
          onSubmit(value);
        }}
      />
    </Editable>
  );
};

const TreeNode = (props) => {
  const {
    isSelected,
    nodeItem,
    dragHandleProps,
    children,
    onClick,
    onExpand,
    onCollapse,
    renderCaret = true,
    handleRenameNode,
    className,
    isEditable = true,
  } = props;
  const { level, isExpanded, name, children: childNodes, isInternal } = nodeItem;
  const lines = Array(isInternal && level >= 1 ? level - 1 : level).fill("line");
  const contentClasses = classNames(TREE_NODE_CONTENT, `${TREE_NODE_CONTENT}-${level}`, {
    [`${TREE_NODE_CONTENT}--active`]: isSelected,
  });

  const maybeRenderCaret = () => {
    const hasCaret = childNodes.length;
    if (hasCaret && renderCaret) {
      const caretClasses = `${TREE_NODE_CARET} ${isExpanded ? TREE_NODE_CARET_OPEN : TREE_NODE_CARET_CLOSED}`;
      return (
        <Icon
          className={caretClasses}
          onClick={(e) => {
            e.stopPropagation();
            if (isExpanded) onCollapse(e);
            else onExpand(e);
          }}
          icon={IconNames.CHEVRON_DOWN}
        />
      );
    }
    return <span className={TREE_NODE_CARET_NONE} />;
  };
  return (
    <li className={classNames(TREE_NODE, { [`${TREE_NODE_COLLAPSED}`]: !isExpanded }, className)} onClick={onClick}>
      <div className={contentClasses}>
        {dragHandleProps ? (
          <Icon icon={IconNames.DRAG_HANDLE} {...dragHandleProps} className={TREE_NODE_CONTENT_DRAG_HANDLE} />
        ) : (
          <span className={TREE_NODE_CONTENT_DRAG_HANDLE} />
        )}
        {lines.map((item, i) => (
          <span key={i} className="at-tree-node-line">
            <span />
          </span>
        ))}
        <Icon icon={IconNames.FOLDER_CLOSED} />
        <EditableInput isEditable={isEditable} defaultValue={name} onSubmit={handleRenameNode} />
        {maybeRenderCaret()}
      </div>
      {children}
    </li>
  );
};
export default TreeNode;
